/**
 * 是否为温度计
 */

export const isTemp = probe => {
  if (!probe) {
    return false
  }
  if (probe.deviceCatalog === 0) {
    const type = probe.deviceType
    if (type === 1 || type === 3 || type === 5 || type === 7 || type === 9) {
      return true
    }
  }
  return false
}

/**
 * 是否是湿度计
 * @param probe
 * @returns {boolean}
 */
export const isHum = probe => {
  if (!probe) {
    return false
  }
  if (probe.deviceCatalog === 0) {
    const type = probe.deviceType

    if (type === 2 || type === 4 || type === 6 || type === 8 || type === 10) {
      return true
    }
  }

  return false
}

/**
 * 是否为传感器
 * @param probe
 * @returns {boolean}
 */
export const isSensor = probe => {
  if (probe.deviceCatalog === 0) {
    return true
  }
  return false
}

/**
 * 是否为传感器--新增了气体和门磁，也是传感器的一类
 * @param probe
 * @returns {boolean}
 */
 export const isSensor2 = probe => {
  if (probe.deviceCatalog === 0 || probe.deviceCatalog === 5 ||probe.deviceCatalog === 6) {
    return true
  }
  return false
}

